var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.activePage && _vm.componentShouldRenderPage('search', 'search_custom_page')
  )?_c('section',[(!_vm.loading && _vm.searchId)?_c('Search'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }